import { TYPES } from "./var.type";

// ------------ set open group ------------- //
export const setOpenGroupAdd =
  ({ data }, callback) =>
  (dispatch) => {
    selectOpenGroupSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const selectOpenGroupSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_OPEN_ADD_GROUP,
    payload: data,
  });
};

// ------------ set open group ------------- //
export const setOpenServiceAdd =
  ({ data }, callback) =>
  (dispatch) => {
    selectOpenServiceSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const selectOpenServiceSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_OPEN_ADD_SERVICE,
    payload: data,
  });
};

// ------------ set detail group ------------- //
export const setOpenGroupDetail =
  ({ data }, callback) =>
  (dispatch) => {
    selectOpenDetailGroupSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const selectOpenDetailGroupSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_OPEN_EDIT_GROUP,
    payload: data,
  });
};

// ------------ set detail group ------------- //
export const selectDetailGroup =
  ({ data }, callback) =>
  (dispatch) => {
    selectDetailGroupSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const selectDetailGroupSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_DETAIL_GROUP,
    payload: data,
  });
};

// ------------ select Detail Service ------------- //
export const setOpenDetailService =
  ({ data }, callback) =>
  (dispatch) => {
    setOpenDetailServiceSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const setOpenDetailServiceSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_OPEN_EDIT_SERVICE,
    payload: data,
  });
};

// ------------ select Detail Service ------------- //
export const selectDetailService =
  ({ data }, callback) =>
  (dispatch) => {
    selectDetailServiceSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const selectDetailServiceSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_DETAIL_SERVICE,
    payload: data,
  });
};

// ------------ set Search ------------- //
export const setSearch =
  ({ data }, callback) =>
  (dispatch) => {
    setSearchSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const setSearchSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_SEARCH,
    payload: data,
  });
};

// ------------ set job services ------------- //
export const setJobServices =
  ({ data }, callback) =>
  (dispatch) => {
    setJobServiceSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const setJobServiceSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_JOB_SERVICE_SUCCESS,
    payload: data,
  });
};

// ------------ set job services ------------- //
export const setGift =
  ({ data }, callback) =>
  (dispatch) => {
    setGiftSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const setGiftSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_GIFT,
    payload: data,
  });
};

// ------------ set staff services ------------- //
export const setStaff =
  ({ data }, callback) =>
  (dispatch) => {
    setStaffSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const setStaffSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_STAFF,
    payload: data,
  });
};

// ------------ set open Receipt ------------- //
export const setOpenReceipt =
  ({ data }, callback) =>
  (dispatch) => {
    setOpenReceiptSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const setOpenReceiptSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_OPEN_RECEIPT,
    payload: data,
  });
};

// ------------ set open Receipt ------------- //
export const setSelected =
  ({ data }, callback) =>
  (dispatch) => {
    setSelectedReceiptSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const setSelectedReceiptSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_RECORD_JOB_SUCCESS,
    payload: data,
  });
};

// ------------ set open Detail Receipt ------------- //
export const setOpenDetailReceipt =
  ({ data }, callback) =>
  (dispatch) => {
    setOpenDetailReceiptSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const setOpenDetailReceiptSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_OPEN_DETAIL_RECEIPT,
    payload: data,
  });
};

// ------------ set assign staff ------------- //
export const setAssignStaff =
  ({ data }, callback) =>
  (dispatch) => {
    setAssginStaffSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const setAssginStaffSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_ASSIGN_STAFF,
    payload: data,
  });
};

// ------------ set assign staff ------------- //
export const setStep =
  ({ data }, callback) =>
  (dispatch) => {
    setStepSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const setStepSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_STEP,
    payload: data,
  });
};

// ------------ set assign staff ------------- //
export const setJob =
  ({ data }, callback) =>
  (dispatch) => {
    setJobSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const setJobSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_JOB,
    payload: data,
  });
};

// ------------ set Feedback ------------- //
export const setFeedback =
  ({ data }, callback) =>
  (dispatch) => {
    setFeedbackSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const setFeedbackSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FEEDBACK,
    payload: data,
  });
};

// ------------ set Staff Feedback ------------- //
export const setStaffFeedback =
  ({ data }, callback) =>
  (dispatch) => {
    setStaffFeedbackSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const setStaffFeedbackSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_FEED_STAFF,
    payload: data,
  });
};

// ------------ set date ------------- //
export const setDate =
  ({ data }, callback) =>
  (dispatch) => {
    setDateSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const setDateSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DATE,
    payload: data,
  });
};

// ------------ set date label ------------- //
export const setDateLabel =
  ({ data }, callback) =>
  (dispatch) => {
    setDateLabelSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const setDateLabelSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_LABEL_DATE,
    payload: data,
  });
};

// ------------ ignore select job ------------- //
export const ignoreSelectJob =
  ({ data }, callback) =>
  (dispatch) => {
    ignoreSelectJobSuccess(dispatch, data);
    if (callback) {
      callback();
    }
  };

// ------------ dispatch ------------- //
const ignoreSelectJobSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.IGNORE_SELECT_JOB,
    payload: data,
  });
};
